import _ from "underscore";
import $ from "jquery";
import queryStringService from "src/shared/query-string-service";

const SCROLL_AFTER_CLICK_TIMEOUT = 1000;

function onButtonClicked(keyword) {
    queryStringService.setParameter(keyword, null);
    const $sectionElement = this.closest("[data-section]");
    const section = $sectionElement && $sectionElement.data("section");
    if (section) {
        const $sidebarLink = $(`[data-section-link='${section}']`);
        if ($sidebarLink) {
            setTimeout(() => {
                $sidebarLink.click();
            }, SCROLL_AFTER_CLICK_TIMEOUT);
        }
    }
}

export default {
    addListeners($parent) {
        const parameters = queryStringService.getParameters();
        const uniqueKeywords = [];
        $parent.find("[data-keyword]").each(function () {
            const $element = $(this);
            const keyword = $element.data("keyword");
            if (!uniqueKeywords.includes(keyword)) {
                uniqueKeywords.push(keyword);
                $element.on("click", onButtonClicked.bind($element, keyword));
                if (_.has(parameters, keyword)) {
                    $element.trigger("click");
                }
            }
        });
    },
};
